import { getTestIds } from 'seagull/utils/TestIds';
import { toastContent } from './toastContent';
export const GetCompletionToastTID = (parentTestId)=>getTestIds(parentTestId);
const { CompletionToastTID } = GetCompletionToastTID();
export const pickTransitionData = (task)=>{
    switch(task.kind){
        case 'relationshipPdf':
            return {
                relationshipId: task.relationshipId,
                agreementName: task.agreementName,
                downloadUrl: task.downloadUrl
            };
        default:
            {
                const _exhaustive = task.kind;
                return _exhaustive;
            }
    }
};
export const buildCompletionToastSpec = (transitions, texts, actions)=>{
    if (transitions.length === 0) return null;
    const ready = transitions.filter((t)=>t.nextStatus === 'ready');
    const failed = transitions.filter((t)=>t.nextStatus === 'failed');
    if (transitions.length === 1) {
        const only = transitions[0];
        if (only.nextStatus === 'ready') {
            const hasUrl = only.downloadUrl != null;
            return {
                kind: 'success',
                content: toastContent(texts.toast.singleReady({
                    name: only.agreementName
                }), hasUrl ? texts.toast.viewPdf() : texts.toast.viewActivity(), hasUrl ? 'tasks_completion_toast_view_pdf' : 'tasks_completion_toast_view_tasks_ready', ()=>hasUrl ? actions.openNewTab(only.downloadUrl) : actions.openDrawer()),
                testId: CompletionToastTID.Success()
            };
        }
        const retryRelationshipId = only.relationshipId;
        if (retryRelationshipId == null) {
            return {
                kind: 'warning',
                content: toastContent(texts.toast.singleFailed({
                    name: only.agreementName
                }), texts.toast.viewActivity(), 'tasks_completion_toast_view_tasks_failed', actions.openDrawer),
                testId: CompletionToastTID.Warning()
            };
        }
        return {
            kind: 'warning',
            content: toastContent(texts.toast.singleFailed({
                name: only.agreementName
            }), texts.toast.retry(), 'tasks_completion_toast_retry', ()=>actions.retry(retryRelationshipId, {
                    previousJobId: only.jobId
                })),
            testId: CompletionToastTID.Warning()
        };
    }
    if (failed.length > 0) {
        return {
            kind: 'warning',
            content: toastContent(texts.toast.manyFailed({
                count: failed.length
            }), texts.toast.viewActivity(), 'tasks_completion_toast_view_tasks_failed', actions.openDrawer),
            testId: CompletionToastTID.Warning()
        };
    }
    return {
        kind: 'success',
        content: toastContent(texts.toast.manyReady({
            count: ready.length
        }), texts.toast.viewActivity(), 'tasks_completion_toast_view_tasks_ready', actions.openDrawer),
        testId: CompletionToastTID.Success()
    };
};
